import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

/**
 * What the practitioner picked when asked about a patient under a temporary deactivation.
 * Closing the dialog any other way leaves the deactivation as it is.
 */
export enum REACTIVATE_CHOICE {
  ACTIVATE = "ACTIVATE",
  UPDATE_DEACTIVATION = "UPDATE_DEACTIVATION",
}

/**
 * Asked before reactivating a patient who is temporarily deactivated: on top of bringing him back,
 * the practitioner can keep him deactivated and change what his deactivation is made of.
 */
@Component({
  selector: "app-patient-reactivate-dialog",
  templateUrl: "./patient-reactivate-dialog.component.html",
  styleUrls: ["./patient-reactivate-dialog.component.scss"],
})
export class PatientReactivateDialogComponent {
  public choices = REACTIVATE_CHOICE;

  constructor(private dialogRef: MatDialogRef<PatientReactivateDialogComponent>) {}

  public onChoice(choice: REACTIVATE_CHOICE): void {
    this.dialogRef.close(choice);
  }
}
